<template>
  <div class="indentity-info">
    <div class="invoice_nav">
      <navbar
        title="请选择纳税人类型"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="content">
      <van-col span="24" class="item" @click="toSupply('小规模纳税人')"
        ><img
          src="@/assets/purchaseSupplier/common/supplier1.png" />小规模纳税人<van-icon
          name="arrow"
      /></van-col>
      <van-col span="24" class="item" @click="toSupply('一般纳税人')"
        ><img
          src="@/assets/purchaseSupplier/common/supplier2.png" />一般纳税人<van-icon
          name="arrow"
      /></van-col>
    </van-row>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
export default {
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      is_resign: 0,
    };
  },
  components: {
    navbar,
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    if (this.$route.query.resign) {
      this.is_resign = 1;
    }
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.params("", "", "goBack");
      }
    },
    toSupply(type) {
      this.$router.push({
        path: "/purchaseSupplier/supply",
        query: {
          supplier_id: this.$route.query.supplier_id,
          type: type,
          resign: this.is_resign,
        },
      });
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less">
.indentity-info {
  overflow-x: hidden;
  padding: 9.2rem 0 5rem;
  box-sizing: border-box;
  color: #333;
  font-size: 1.4rem;
  background: #f5f6f7;
  height: 100%;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .content {
    padding: 0 1.6rem;

    .item {
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;
      height: 7.8rem;
      line-height: 7.8rem;
      background: #fff;
      border-radius: 0.8rem;
      padding: 0 2.8rem;
      margin-top: 1.2rem;

      img {
        width: 2.2rem;
        margin: 2.8rem 2rem 0 0;
        float: left;
      }

      .van-icon {
        color: #999;
        width: 1.6rem;
        height: 1.6rem;
        float: right;
        margin-top: 3.1rem;
      }
    }
  }
}
</style>





